import { render, staticRenderFns } from "./SchoolStaffApproval.vue?vue&type=template&id=431921b3&scoped=true&"
import script from "./SchoolStaffApproval.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431921b3",
  null
  
)

export default component.exports